// Applique du colonnage dans les formulaires Ninja forms
function ninjaFormGrid() {

    $(document).on( 'nfFormReady', function(e) {
        // Récupération des champs
        const inputsForm = $("nf-field");

        // Sélecteurs devant passer sur une ligne
        const fullRowSelectors = [
            '.checkbox-container',
            '.textarea-container',
            '.submit-container'
        ];

        console.log(window.email);


        inputsForm.each(function() {

            // On boucle sur les sélecteurs CSS
            fullRowSelectors.forEach(selector => {
                if ($(this).find(selector).length > 0) {
                    $(this).addClass('full-row');
                }
            });
        });
    });

    
}

function newsletter() {
    $(document).on( 'ready', function(e) {
        if ($('.sib_signup_form').length > 0 && $("#email_newsletter").length > 0 && $("#email_newsletter").val() != "") {
            $('.sib_signup_form').find("input[type='email']").first().val($("#email_newsletter").val());
        }
    });
}

  
function track_initiate_form() {
    var el = "";
    var type = "";
    var typeBrochure = ["9", "10", "11", "12", "19", "21", "22", "24", "25", "26", "27", "28", "29", "37"];
    var typeContact = ["1", "3", "4", "5", "6", "7", "8", "14", "15", "18", "20", "30", "31", "32", "33", "34", "35", "39", "40", "41", "42", "43", "47", "50"];
    var typeCatalogue = ["13"];
    var typeResultatConseil = ["45"];
    var ninjaID = "";
    var inputType = "";
    $(document).on('nfFormReady', function (e) {
        if (!$('body').hasClass('admin-bar')) {
            el = $(".nf-form-cont").find("input[type='text'], input[type='email']")[0];
            if (el.classList.contains("nf-field-hp")) {
                el = $(".nf-form-cont").find("input[type='checkbox']").parents('.nf-row')[0];
            }
            ninjaID = form.id;
        
            if (ninjaID) {
                if (typeBrochure.includes(ninjaID)) {
                    type = "brochure";
                } else if (typeContact.includes(ninjaID)) {
                    type = "contact";
                } else if (typeCatalogue.includes(ninjaID)) {
                    type = "cataloguebtoc";
                } else if (typeResultatConseil.includes(ninjaID)) {
                    type = "resultatconseil";
                } else {
                    type = $('.tracking_type').val();
                }
            }
            
            if (type) {
                el.addEventListener('click', function (e) {
                    var className = 'tracking-fired';
    
                    if ((' ' + el.className + ' ').indexOf(' ' + className + ' ') > -1) {
                        console.log('initiate_' + type + ' not fired');
                    } else {
                        console.log('initiate_' + type + ' fired');
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                        'event': 'initiate_' + type
                        });
                    }
                
                    el.classList.add("tracking-fired");
                });
            }
        }
    });
} // Applique un formatage aux champs Ultimate Members

// Applique un formatage aux champs Ultimate Members
function umForm() {

    // Applique une classe au parent du champ confirmation de mot de passe
    const passwordConfirmFields = document.querySelectorAll('[data-key="confirm_user_password');
    console.log('passwordConfirmFields', passwordConfirmFields);
    if (passwordConfirmFields) {

        passwordConfirmFields.forEach(field => {
            const parent = field.parentNode;
            console.log('parent', parent);
    
            if (parent) {
                const parentClass = parent.getAttribute('class');
                if (parentClass.includes('um-col')) {
                    parent.classList.add('-contains-password-confirm-field')
                }
            }
        });

        
    }

}

// permet de forcer un valeur positif dans un element du DOM dans un formulaire NF multi part
function forcePositifValue(el) {
    $(document).on('click', function() {
        var element = $(el);
        var current_input_value = element.text();
        element.text(current_input_value.replace("-", "")); 
    });
}

export default function() {
    track_initiate_form();
    // ninjaFormGrid();
    // umForm();
    newsletter();
    forcePositifValue('#nf-field-826-wrap .nf-field-element .read-value span');
}

